/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 27/4/2023
 */

import { apiSlice } from '../Slices/apiSlice';

export const imageService = apiSlice.injectEndpoints({
  endpoints: builder => ({

    uploadImages: builder.mutation({
      query: (images) => ({
        url: '',
        method: 'POST',
        body: images
      }),
    }),

    deleteImage: builder.mutation({
      query: (path) => ({
        url: `?key=${path}`,
        method: "DELETE",
      }),
    }),

    deleteFolder: builder.mutation({
      query: () => ({
        url: ``,
        method: "DELETE",
      }),
    }),

    uploadCategoryImage: builder.mutation({
      query: (images) => ({
        url: '',
        method: 'POST',
        body: images
      }),
    }),

    deleteCategoryFolder: builder.mutation({
      query: () => ({
        url: ``,
        method: "DELETE",
      }),
    }),

  })
});

export const {
    useUploadImagesMutation,
    useDeleteImageMutation,
    useDeleteFolderMutation,
    useUploadCategoryImageMutation,
    useDeleteCategoryFolderMutation
} = imageService;